module.exports = __webpack_public_path__ + "static/img/theme.5212777f.svg";